export const POPUP_HIDE_DELAY = 15000;
export const NOTIFICATION_HIDE_DELAY = 5000;
export const NETWORK_DOWN_DELAY = 10000;
